export default __webpack_public_path__ + "static/media/oscer-pres-dysuria.0c250457.svg";